import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import Swal from "sweetalert2";
import GreenButton from '../../../ui/GreenButton.js';
import * as XLSX from 'xlsx';

const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius:   0px 0px 15px 15px;
  border: 1px solid #eee;
  border-top: none;
`;
const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  width: 98%;   
  margin: auto;   
  padding: 12px;
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;


export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  
  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #555;
  text-align: left;
`;


export const Td = styled.td`
  word-break: break-word;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
`;



export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  
`;




const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;


const Grid = ({ modalEditarUsuario, urlApi, usuarios, fetchUsuarios, modalEditarCadastrarUsuario, modalLogsUsuario }) => {

  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  //----------------------------------------CHAMA o MODAL DE EDITAR USUARIO E ACESSOS--------------------------------------------------///

  const handleEdit = (item) => {
    modalEditarUsuario(item);

  };

  //---------------------------------------FUNÇÂO DELETAR USUARIO---------------------------------------------------//


  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja deletar o usuário?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDelete = async (item) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}portal/deletar-usuario/${item.COD_FUNCIONARIO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Usuário deletado com sucesso.");
      await logEvento(id, `Deletou o usuario ${item.COD_FUNCIONARIO}-${item.LOGON}`);

    } catch (error) {
      console.log(isLoading)
      toast.error(error);
      await logEvento(id, `Erro ao deletar o usuario ${item.COD_FUNCIONARIO}-${item.LOGON}`);

    }

    //setOnEdit(null);
    fetchUsuarios();
  };

  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(usuarios);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = usuarios.filter((user) => {
        const cracha = (user.COD_FUNCIONARIO || '').toString().toLowerCase();
        const login = (user.LOGON || '').toLowerCase();
        const nome = (user.NOME || '').toLowerCase();
        const email = (user.EMAIL || '').toLowerCase();


        return (
          cracha.includes(term.toLowerCase()) ||
          login.includes(term.toLowerCase()) ||
          nome.includes(term.toLowerCase()) ||
          email.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, usuarios]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  //---------------------------------------MODAL CADASTRAR USUARIOS---------------------------------------------------//
  // Chama o modal de cadastrar usuários
  const handleCadastrarUsuario = () => {
    modalEditarCadastrarUsuario()
  };
  //---------------------------------------MODAL LOGS USUARIOS---------------------------------------------------//
  // Chama o modal de cadastrar usuários
  const handleLogsUsuario = () => {
    modalLogsUsuario()
  };

  //---------------------------------------SALVANDO LOG DE ALTERACAO---------------------------------------------------------------//

  // Passa o logs para serem salvos no banco
  const logEvento = async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      const response = await fetch(`${urlApi}portal/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error('Failed to save log');
      }
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  };



  //---------------------------------------EXPORTAR EXCEL ---------------------------------------------------//


  const exportarParaExcel = (dados, nomeArquivo = 'usuarios_portal_colaborador.xlsx') => {
    // Mapeia os dados para o Excel
    const dadosFormatados = dados.map(item => ({
      'Crachá': item.COD_FUNCIONARIO,
      'Login': item.LOGON,
      'Nome': item.NOME,
      'Email': item.EMAIL
    }));

    // Cria uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosFormatados);

    // Cria um workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Usuários');

    // Exporta
    XLSX.writeFile(wb, nomeArquivo);
  };

  return (



    <Container>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar... Ex: login, nome ou email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Select value={itemsPerPage} onChange={(e) => {
          const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
          setItemsPerPage(value);
          setCurrentPage(1); // Resetar para a primeira página sempre que mudar
        }}>
          <option value={10}>10 por página</option>
          <option value={50}>50 por página</option>
          <option value={100}>100 por página</option>
          <option value="all">Todos</option>
        </Select>

        {/* <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div> */}

        <Div>
          <GreenButton onClick={handleCadastrarUsuario}>
            Cadastrar Usuário
          </GreenButton>
        </Div>
        <Div>
          <GreenButton onClick={handleLogsUsuario}>
            Log dos usuários
          </GreenButton>
        </Div>
        <Div>
          <GreenButton onClick={() => exportarParaExcel(usuarios)}>
            Exportar Excel
          </GreenButton>
        </Div>
      </Td3>

      {currentItems.length === 0 ? (
        <Tr>
          <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
            Nenhum usuário encontrado.
          </Td>
        </Tr>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th onClick={() => onColumnClick("COD_FUNCIONARIO")} className={getSortClass("COD_FUNCIONARIO")}>
                  Crachá {getSortIcon("COD_FUNCIONARIO")}
                </th>

                <th onClick={() => onColumnClick("LOGON")} className={getSortClass("LOGON")}>
                  Login {getSortIcon("LOGON")}
                </th>

                <th onClick={() => onColumnClick("NOME")} className={getSortClass("NOME")}>
                  Nome {getSortIcon("NOME")}
                </th>

                <th onClick={() => onColumnClick("EMAIL")} className={getSortClass("EMAIL")}>
                  Email {getSortIcon("EMAIL")}
                </th>

                <th></th>
                <th></th>

              </tr>
            </thead>

            <tbody>
              {currentItems.map((item, i) => (
                <tr key={i}>
                  <td >{item.COD_FUNCIONARIO}</td>
                  <td >{item.LOGON}</td>
                  <td >{item.NOME}</td>
                  <td >{item.EMAIL}</td>

                  <td>
                    <ActionButton onClick={() => handleEdit(item)}>
                      Editar
                    </ActionButton>
                  </td>
                  <td>
                    <ActionButton onClick={() => handleDelete(item)}>
                      Deletar
                    </ActionButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

      )}
      <Td3 colSpan="7">


        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>


      </Td3>

    </Container>
  );
};


export default Grid;
